<template>
  <div id="app">
    <RoxyTable></RoxyTable>
    <MyGraph></MyGraph>
    <EnvGraph></EnvGraph>
  </div>
</template>

<script>
import RoxyTable from './components/RoxyTable.vue'
import MyGraph from './components/MyGraph.vue'
import EnvGraph from './components/EnvGraph.vue'

export default {
  name: 'App',
  components: {
    RoxyTable,
    MyGraph,
    EnvGraph
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
